module.exports = __webpack_public_path__ + "static/media/wall1.bed2b860.jpg";